// @flow

import React, { PureComponent } from 'react';
import ConnectViewer from 'app/common/react/components/common/ConnectViewer/ConnectViewer';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import type { AuthViewer } from 'app/packages/pinterest-flow-types/viewer';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Button, Heading, Text } from 'gestalt';

type Props = {|
  completeButtonText: string,
  completeButtonUrl?: string,
  headerSubtitle: string,
  handleComplete: () => void,
  handleDismiss: () => void,
|};

type State = {|
  hasCompleted: boolean,
|};

export default class WelcomeHero extends PureComponent<Props, State> {
  static defaultProps = {
    completeButtonUrl: '',
  };

  state = {
    hasCompleted: false,
  };

  handleCompleteExperience = () => {
    this.props.handleComplete();
    this.setState({ hasCompleted: true });
  };

  render() {
    const { completeButtonText, completeButtonUrl, headerSubtitle } = this.props;

    return (
      <ConnectViewer>
        {(viewer: AuthViewer) => (
          <Box
            display="flex"
            justifyContent="center"
            position="relative"
            color="blue"
            dangerouslySetInlineStyle={{ __style: { zIndex: 1 } }} // to cover Back button
          >
            <Box display="flex" justifyContent="between" alignItems="end" width={864} margin={7}>
              <Box marginRight={5}>
                <Box marginBottom={2}>
                  <Heading size="sm" color="white">
                    {interpolateNamedTemplate(
                      i18n._(
                        'Welcome back, {{ name }}',
                        'shown on a banner, "welcome back, first_name"',
                      ),
                      { name: viewer.firstName },
                    )}
                  </Heading>
                </Box>
                <Text size="xl" color="white">
                  {headerSubtitle}
                </Text>
              </Box>
              <Box minWidth={120}>
                <NavigateLink to={completeButtonUrl}>
                  <Button
                    size="lg"
                    text={completeButtonText}
                    onClick={this.handleCompleteExperience}
                  />
                </NavigateLink>
              </Box>
            </Box>
          </Box>
        )}
      </ConnectViewer>
    );
  }
}
